<template lang="pug">

  section.decades
    .tlwrap(:style="{ height: getTlHeight + 'px' }")
      TimelineHeader(:sticky="topviewport")
    .decade-wrap(v-for="decade in getDecades" :key="decade.title")
      Decade(:title="decade.title" :stcontent="decade.content" :carmodel="decade.carmodel" :orientation="decade.orientation" :carpic="decade.carpic" :colorBackground="decade.colorscheme.background" :colorTitle="decade.colorscheme.title" :colorText="decade.colorscheme.text" :colorCar="decade.colorscheme.car" v-observe-visibility="observeOptions(decade)")
    .banner
      Banner

</template>

<script>
  import _ from 'lodash'
  import { mapActions, mapGetters } from 'vuex'
  import Decade from '@/components/timeline/Decade'
  import TimelineHeader from '@/components/timeline/TimelineHeader'
  import Banner from '@/components/timeline/Banner'

  export default  {
    name: 'decades',
    components: {
      Decade,
      TimelineHeader,
      Banner
    },
    props: [],
    mounted() {
      window.addEventListener('scroll', _.throttle(this.stickScroll, 100));
    },
    data() {
      return {
        topviewport: false
      }
    },
    methods: {
      stickScroll() {
        const rect = this.$el.getBoundingClientRect()
        const headerPosition = this.getHeaderPosition
        if(rect.top <= headerPosition ) {
          this.topviewport = true
        } else {
          this.topviewport = false
        }
      },
      visibilityChanged (isVisible, entry, decadeTitle) {
        if(isVisible){
          this.setActiveDecade(decadeTitle)
          this.setVideoNotifier(decadeTitle)
        }
      },
      observeOptions(decade) {
        return {
          callback: (isVisible, entry) => this.visibilityChanged(isVisible, entry, decade.title),
          intersection: {
            threshold: [0.15]
          }
        }
      },
      ...mapActions([
        'setActiveDecade',
        'setVideoNotifier'
      ])
    },
    computed: {
      ...mapGetters([
        'getDecades',
        'getTlHeight',
        'getHeaderPosition'
      ]),
    }
}
</script>

<style scoped lang="scss">
  .decade-wrap {
  }
  .tlwrap {
    height: 112px;
    margin-left: -1rem;
    margin-right: -1rem;
    @media screen and (max-width: 600px){
      height: 90px;
    }
  }
</style>
